import { View } from 'backbone.marionette';
import _ from 'lodash';

import SpecialtyRequirementDeliveryScheduleGridView from '@/views/SpecialtyRequirementDeliveryScheduleGridView';

import OrderAccess from '../../../utils/OrderAccess';

import tmplMFDDeliveryview from './SpecialtyRequirementDeliveryView.hbs';

const SpecialtyRequirementDeliveryView = View.extend({
  template: tmplMFDDeliveryview,

  className: 'specialty-requirement-delivery-view',

  ui: {
    deliveryGrid: '.delivery-grid',
    deliveryInfoError: '.delivery-info-error'
  },

  regions: {
    deliveryGrid: '@ui.deliveryGrid'
  },

  onRender() {
    const orderDetails = this.model.get('orderDetails');
    const deliveryGrid = new SpecialtyRequirementDeliveryScheduleGridView({
      objectTypeCode: 'ORDER',
      objectID: orderDetails.orderId,
      itPOCExists: true,
      gridName: 'deliveryScheduleGrid',
      isPriceVisible: OrderAccess.isPriceVisible(orderDetails.orderDetails),
      model: this.model,
      editable: !this.model.get('isReadOnly')
    });
    this.showChildView('deliveryGrid', deliveryGrid);
    // deliveryGrid.getViewGrid().sort('clin', 'ascending');
  },

  validate() {
    let isValid = true;
    const coll = this.getDeliveryData();
    const reqFields = [
      'deliveryPOCName',
      'deliveryPOCEmail',
      'deliveryPOCPhone',
      'itPOCName',
      'itPOCEmail',
      'itPOCPhone',
      'addressLine1',
      'buildingFloorNumber',
      'floorNumber',
      'city',
      'regionName',
      'zip'
    ];
    _.each(coll, (item) => {
      _.each(reqFields, (field) => {
        if (!item[field] && !item.address[field]) {
          isValid = false;
          this.ui.deliveryInfoError.show();
        }
      });
    });
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async getDeliveryGridCSV(isTemplate) {
    const deliveryGrid = this.getChildView('deliveryGrid');
    if (isTemplate) {
      return await deliveryGrid.downloadTemplateCSV();
    } else {
      return await deliveryGrid.generateAndDownloadCSV();
    }
  },

  getDeliveryData() {
    this.ui.deliveryInfoError.hide();
    this.trigger('no:errors');
    const coll = this.getChildView('deliveryGrid').model.get('schedules');
    return coll;
  }
});

export default SpecialtyRequirementDeliveryView;
